import axios from 'axios';

/**
 * get getExchangeList
 */
export const getExchangeList = data => axios.$callAPI(() => axios.get('exchanges/search', { params: data }));

/**
 * get tagInfo
 */
export const getExchangeInfo = id => axios.$callAPI(() => axios.get('/exchanges/' + id));

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('exchanges/', data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('exchanges/' + id));
/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('exchanges/', { data: ids }));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('exchanges/' + id, data));
